import { render } from "./DemandShowModal.vue?vue&type=template&id=80961c3e&scoped=true"
import script from "./DemandShowModal.vue?vue&type=script&lang=js"
export * from "./DemandShowModal.vue?vue&type=script&lang=js"

import "./DemandShowModal.vue?vue&type=style&index=0&id=80961c3e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80961c3e"]])

export default __exports__